import { getLocalParticipant, getParticipantById, getRaiseHandsQueue, getSortedModeratorList, getVirtualScreenshareParticipantOwnerId } from '../base/participants/functions';
import { setRemoteParticipants } from './actions';
import { isFilmstripScrollVisible } from './functions';
/**
 * Computes the reorderd list of the remote participants.
 *
 * @param {*} store - The redux store.
 * @param {boolean} force - Does not short circuit, the execution, make execute all checks.
 * @param raisedHandParticipantsQueue
 * @returns {void}
 * @private
 */
export function updateRemoteParticipants(store, force, raisedHandParticipantsQueue) {
    const state = store.getState();
    let reorderedParticipants = [];
    const { sortedRemoteVirtualScreenshareParticipants } = state['features/base/participants'];
    if (!isFilmstripScrollVisible(state) && !sortedRemoteVirtualScreenshareParticipants.size && !force) {
        return;
    }
    const { fakeParticipants, sortedRemoteParticipants } = state['features/base/participants'];
    const remoteParticipants = new Map(Array.from(sortedRemoteParticipants.entries()).map(([id, name]) => {
        const remoteParticipant = getParticipantById(state, id);
        return [id, { name, joinedAt: remoteParticipant?.joinedAt || 9999999999 }];
    }));
    const localParticipant = getLocalParticipant(state);
    const screenShareParticipants = sortedRemoteVirtualScreenshareParticipants
        ? [...sortedRemoteVirtualScreenshareParticipants.keys()] : [];
    const sharedVideos = fakeParticipants ? Array.from(fakeParticipants.keys()) : [];
    const raisedHandQueue = raisedHandParticipantsQueue ?? getRaiseHandsQueue(state);
    const raisedHandParticipants = raisedHandQueue.map(({ id: particId }) => particId);
    const remoteRaisedHandParticipants = new Set(raisedHandParticipants || []);
    const moderatorsMap = getSortedModeratorList(state);
    if (localParticipant !== undefined && remoteRaisedHandParticipants.has(localParticipant.id)) {
        remoteRaisedHandParticipants.delete(localParticipant.id);
    }
    for (const participant of moderatorsMap.keys()) {
        // Avoid duplicates.
        if (remoteRaisedHandParticipants.has(participant)) {
            remoteRaisedHandParticipants.delete(participant);
        }
        if (remoteParticipants.has(participant)) {
            remoteParticipants.delete(participant);
        }
    }
    for (const participant of remoteRaisedHandParticipants.keys()) {
        // Avoid duplicates.
        if (remoteParticipants.has(participant)) {
            remoteParticipants.delete(participant);
        }
    }
    for (const screenshare of screenShareParticipants) {
        const ownerId = getVirtualScreenshareParticipantOwnerId(screenshare);
        remoteParticipants.delete(ownerId);
        remoteParticipants.delete(screenshare);
    }
    for (const sharedVideo of sharedVideos) {
        remoteParticipants.delete(sharedVideo);
    }
    // Always update the order of the thumbnails.
    const participantsWithScreenShare = screenShareParticipants.reduce((acc, screenshare) => {
        const ownerId = getVirtualScreenshareParticipantOwnerId(screenshare);
        acc.push(ownerId);
        acc.push(screenshare);
        return acc;
    }, []);
    // сортируем по id от меньшего к большему
    // НЕ сортируем по id remoteRaisedHandParticipants, чтобы их порядок сохранился по очереди поднятия руки
    participantsWithScreenShare.sort((a, b) => a.localeCompare(b));
    sharedVideos.sort((a, b) => a.localeCompare(b));
    const reorderedRemoteParticipants = Array.from(remoteParticipants)
        .sort(([, aData], [, bData]) => aData.joinedAt - bData.joinedAt) // Сортируем по joinedAt
        .map(([id]) => id); // Преобразуем обратно в массив id
    reorderedParticipants = [
        ...Array.from(remoteRaisedHandParticipants.keys()),
        ...Array.from(moderatorsMap.keys()),
        ...participantsWithScreenShare,
        ...sharedVideos,
        ...reorderedRemoteParticipants
    ];
    store.dispatch(setRemoteParticipants(Array.from(new Set(reorderedParticipants))));
}
/**
 * Private helper to calculate the reordered list of remote participants when a participant leaves.
 *
 * @param {*} store - The redux store.
 * @param {string} participantId - The endpoint id of the participant leaving the call.
 * @returns {void}
 * @private
 */
export function updateRemoteParticipantsOnLeave(store, participantId = null) {
    if (!participantId) {
        return;
    }
    const state = store.getState();
    const { remoteParticipants } = state['features/filmstrip'];
    const reorderedParticipants = new Set(remoteParticipants);
    reorderedParticipants.delete(participantId)
        && store.dispatch(setRemoteParticipants(Array.from(reorderedParticipants)));
}
/**
 * Returns whether tileview is completely disabled.
 *
 * @param {IReduxState} state - Redux state.
 * @returns {boolean} - Whether tileview is completely disabled.
 */
export function isTileViewModeDisabled(state) {
    const { tileView = {} } = state['features/base/config'];
    return tileView.disabled;
}
